import React, { useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import config from '../../config';
import './About.css';

export default function About() {
    const [init, setInit] = useState(false);

    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadSlim(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    const particlesOptions = {
        background: { color: { value: "transparent" } },
        fpsLimit: 60,
        interactivity: {
            events: { onHover: { enable: true, mode: "grab" } },
            modes: { grab: { distance: 150 } },
        },
        particles: {
            color: { value: config.theme.primary },
            links: {
                color: config.theme.primary,
                distance: 120,
                enable: true,
                opacity: 0.2,
            },
            move: { enable: true, speed: 1 },
            number: { density: { enable: true, area: 800 }, value: 50 },
            size: { value: { min: 1, max: 2 } },
        },
    };

    return (
        <div className="about-page-container">
            {init && <Particles id="tsparticles" options={particlesOptions} className="particles-bg" />}

            <div className="about-content-wrapper">
                <h2 className="about-title" style={{ color: config.theme.primary }}>
                    ABOUT {config.appName}
                </h2>

                <div className="animated-card">
                    <h3 style={{ color: config.theme.primary, marginBottom: '15px' }}>
                        {config.developer}
                    </h3>

                    <p style={{ color: config.theme.textMuted, lineHeight: '1.6', fontSize: '14px' }}>
                        Kreator Xyrons Hub, sebuah platform All-in-One untuk eksplorasi AI dan riset teknologi. Menggabungkan performa teknologi tinggi dengan filosofi desain Wolf & Compass untuk menciptakan pengalaman browsing yang eksklusif dan aman.
                    </p>

                    <div className="tag-container">
                        <div style={{ ...tagStyle, borderColor: config.theme.primary, color: config.theme.primary }}>
                            MODERN UI
                        </div>
                        <div style={{ ...tagStyle, borderColor: config.theme.secondary, color: config.theme.secondary }}>
                            VERIFIED
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const tagStyle = {
    padding: '6px 12px',
    background: 'rgba(0, 210, 255, 0.05)',
    border: '1px solid',
    borderRadius: '4px',
    fontSize: '10px',
    fontWeight: 'bold',
    letterSpacing: '1px'
};